module.exports = __webpack_public_path__ + "static/media/image.9e2ac379.gif";